import request from '@/services/base-service';
import { IReportLogoView, IConfigResponse } from '@/types/config';
import { InternalAxiosRequestConfig } from 'axios';

const BASE_URL = '/v1';

export const configApi = {
  // Lấy toàn bộ cấu hình (full ConfigSDK)
  getFull: () =>
    request.post<IConfigResponse>(`${BASE_URL}/config/getfull`, {}, { authorization: true } as InternalAxiosRequestConfig),

  // Lấy chỉ key & content (giảm data thừa)
  getKeys: () =>
    request.post<{ data: Record<string, { key: string; content?: string }> }>(`${BASE_URL}/config/getkeys`, {}, { authorization: true } as InternalAxiosRequestConfig),

  // Cập nhật cấu hình
  update: (data: IReportLogoView, type?: string) =>
    request.put<{ success: boolean; data: IReportLogoView; message?: string }>(`${BASE_URL}/config${type ? `?type=${type}` : ''}`, data, {
      authorization: true,
    } as InternalAxiosRequestConfig),
};
